import styled from 'styled-components'

import gigplanetTheme from '../../styles/gigplanetTheme'

export const IntroWrapper = styled.div`
  padding: 30px 0;
`
